/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@kubb/plugin-client/clients/fetch';
import type {
  DeleteSessionMutationResponse,
  DeleteSessionPathParams,
  DeleteSession401,
  DeleteSession403,
  DeleteSession404,
} from '../types/DeleteSession.ts';
import type { Client, RequestConfig, ResponseErrorConfig } from '@kubb/plugin-client/clients/fetch';

function getDeleteSessionUrl(id: DeleteSessionPathParams['id']) {
  const res = { method: 'DELETE', url: `/sessions/${id}` as const };
  return res;
}

/**
 * @summary Delete session
 * {@link /sessions/:id}
 */
export async function deleteSession(id: DeleteSessionPathParams['id'], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteSessionMutationResponse,
    ResponseErrorConfig<DeleteSession401 | DeleteSession403 | DeleteSession404>,
    unknown
  >({ method: 'DELETE', url: getDeleteSessionUrl(id).url.toString(), ...requestConfig });
  return res.data;
}
